import * as React from "react";
import * as S from "./messageRowCopy.styled";
import { Check, Copy } from "lucide-react";
import * as Sentry from "@sentry/react";

interface Props {
  content: string;
}

export const OpenChatMessageRowCopy: React.FC<Props> = ({ content }) => {
  const [copied, setCopied] = React.useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(content.trim());
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      Sentry.captureException(error);
    }
  };
  return (
    <S.Container className="ml-auto mt-1 flex rounded-md p-1 text-xs text-white" onClick={handleCopy}>
      {copied ? <Check size={14} className="mr-1" /> : <Copy size={14} className="mr-1" />}
      {copied ? "Copied" : "Copy"}
    </S.Container>
  );
};
